import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function TwitterDownloader() {
  useEffect(() => {
    document.title = 'Twitter Video Downloader — Download Twitter/X Videos & GIFs Free';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', 'Download Twitter (X) videos and GIFs in HD quality for free. Save any tweet video directly to your device. No registration required.');

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: 'How to Download Twitter Videos',
      step: [
        { '@type': 'HowToStep', position: 1, text: 'Copy the tweet URL containing the video you want to download.' },
        { '@type': 'HowToStep', position: 2, text: 'Paste the URL into HD Video Download.' },
        { '@type': 'HowToStep', position: 3, text: 'Click Download and save the video to your device.' },
      ],
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <div className="app">
      <div className="container page-content">
        <Link to="/" className="back-link">&larr; Back to Downloader</Link>
        <h1 className="page-title">Twitter Video Downloader</h1>
        <p className="page-subtitle">Download videos and GIFs from Twitter (X) in HD quality for free.</p>

        <div className="cta-section" style={{ marginTop: '1.5rem', marginBottom: '2rem' }}>
          <Link to="/" className="cta-btn">Download Twitter Video Now</Link>
        </div>

        <h2 className="section-title">How to Download Twitter Videos</h2>
        <div className="steps">
          <div className="step"><span className="step-number">1</span><div><h3>Copy Tweet URL</h3><p>Find the tweet with the video, tap the share icon, and copy the link. Works with both twitter.com and x.com URLs.</p></div></div>
          <div className="step"><span className="step-number">2</span><div><h3>Paste & Download</h3><p>Paste the tweet URL into hdvideodownload.com and click "Download" to see available qualities.</p></div></div>
          <div className="step"><span className="step-number">3</span><div><h3>Save Video</h3><p>Choose your preferred quality and the video will be saved directly to your device as MP4.</p></div></div>
        </div>

        <h2 className="section-title">Features</h2>
        <div className="seo-features">
          <div className="seo-feature"><h3>HD Quality</h3><p>Download Twitter videos in the highest quality available — up to 1080p HD.</p></div>
          <div className="seo-feature"><h3>GIF Support</h3><p>Save Twitter GIFs as MP4 video files that play on any device.</p></div>
          <div className="seo-feature"><h3>Instant Download</h3><p>Twitter videos download instantly — no waiting, no processing time.</p></div>
        </div>

        <div className="cta-section">
          <Link to="/" className="cta-btn">Download Twitter Videos Free</Link>
        </div>
      </div>
      <footer className="footer">
        <span>&copy; {new Date().getFullYear()} hdvideodownload.com — All rights reserved.</span>
        <a href="mailto:hdvideodownload44@gmail.com" className="footer-mail">hdvideodownload44@gmail.com</a>
      </footer>
    </div>
  );
}

export default TwitterDownloader;
